'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (unit) {
    return {
        t: 'Ticks',
        s: 'Seconds',
        m: 'Minutes',
        h: 'Hours',
        d: 'Days'
    }[unit];
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/duration/durationText.js
// module id = 612
// module chunks = 0